import { history } from "@helpers/history";

export default function navigateTo(pathname) {
  history.navigate(pathname);
}
